import { LOADING_UI, UPLOADING } from "../types";
import { db } from "../../firebase/firebase";
import logAnalyticsEvent from "../../utils/logAnalyticsEvent";
import { uploadFile } from "./utils";

export const addOrganization = ({ name, reportLinkID }) => dispatch => {
    dispatch({ type: LOADING_UI, payload: true });
    db.collection("organizations").add({ name, reportLinkID });
    logAnalyticsEvent("add_organization", { title: name });
};

export const editOrganization = ({ key, name, reportLinkID }) => dispatch => {
    dispatch({ type: LOADING_UI, payload: true });
    db.collection("organizations")
        .doc(key)
        .update({ name, reportLinkID });
};

export const changeBackground = ({ image, orgKey }) => dispatch => {
    dispatch({ type: LOADING_UI, payload: true });
    dispatch({ type: UPLOADING, payload: { status: true, title: "Background Image" } });
    const imageName = "organizations/" + orgKey + "/background.png";
    uploadFile(imageName, image, dispatch).then(url => {
        dispatch({ type: UPLOADING, payload: { status: false } });
        db.collection("organizations")
            .doc(orgKey)
            .update({
                background: url
            });
    });
};

export const removeBackground = ({ orgKey }) => dispatch => {
    dispatch({ type: LOADING_UI, payload: true });
    db.collection("organizations")
        .doc(orgKey)
        .update({
            background: ""
        });
};

export const removeTopLogo = ({ orgKey }) => dispatch => {
    dispatch({ type: LOADING_UI, payload: true });
    db.collection("organizations")
        .doc(orgKey)
        .update({
            topLogo: ""
        });
};

export const removeBottomLogo = ({ orgKey }) => dispatch => {
    dispatch({ type: LOADING_UI, payload: true });
    db.collection("organizations")
        .doc(orgKey)
        .update({
            bottomLogo: ""
        });
};

export const changeTopLogo = ({ image, orgKey }) => dispatch => {
    dispatch({ type: LOADING_UI, payload: true });
    dispatch({ type: UPLOADING, payload: { status: true, title: "Top Logo Image" } });
    const imageName = "organizations/" + orgKey + "/toplogo.png";
    uploadFile(imageName, image, dispatch).then(url => {
        dispatch({ type: UPLOADING, payload: { status: false } });
        db.collection("organizations")
            .doc(orgKey)
            .update({
                topLogo: url
            });
    });
};

export const changeBottomLogo = ({ image, orgKey }) => dispatch => {
    dispatch({ type: LOADING_UI, payload: true });
    dispatch({ type: UPLOADING, payload: { status: true, title: "Bottom Logo Image" } });
    const imageName = "organizations/" + orgKey + "/bottomlogo.png";
    uploadFile(imageName, image, dispatch).then(url => {
        dispatch({ type: UPLOADING, payload: { status: false } });
        db.collection("organizations")
            .doc(orgKey)
            .update({
                bottomLogo: url
            });
    });
};
